import { render } from "./ThemeToggleButton.vue?vue&type=template&id=184baf7a"
import script from "./ThemeToggleButton.vue?vue&type=script&lang=js"
export * from "./ThemeToggleButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__